import {copilot} from '@cl/shared';
import {BreadcrumbName} from 'common/src/modules/breadcrumbs/breadcrumbs.enums';
import brandGuidelinesContext from 'common/src/modules/brandGuidelines/copilot/contexts/brandGuidelinesContext';
import brandGuidelinesNavigationContext from 'common/src/modules/brandGuidelines/copilot/contexts/brandGuidelinesNavigationContext';
import brandPersonasContext from 'common/src/modules/brandGuidelines/copilot/contexts/brandPersonasContext';
import {CLStore} from 'common/src/redux/store';

function initializeBrandGuidelinesUiContexts(store: CLStore) {
  copilot.uiContexts.registerUiContexts(BreadcrumbName.BrandGuidelinesPage, {
    description:
      'The brand guidelines page manages brand identity, voice, image guidelines, colors, and navigation between brand tabs.',
    contexts: [brandGuidelinesNavigationContext(), brandGuidelinesContext(store)],
  });

  copilot.uiContexts.registerUiContexts(BreadcrumbName.BrandPersonas, {
    description: 'The brand personas tab manages brand persona definitions and configurations.',
    contexts: [brandPersonasContext(store)],
  });
}

export default initializeBrandGuidelinesUiContexts;
